import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import UploadDocument from "../../comman/UploadDocument";
import { getAlert } from "../../services/appAlerts";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { AddEditBackgroundChecks, getBcAddEditStatus, getLocalDocUploadSasUrl } from "../../app/store/candidate";
import { uploadFileToBlob } from "../../services/blobUploadService";

const AddBcChecks = (props) => {
  const { bcCheckShowHide, handleBcCheckShowHide, bcType,
    candidateObj, workItem, bcObject } = props;

  const [documents, setDocuments] = useState([]);
  const [saveBtnStatus, setSaveBtnStatus] = useState(false);
  const [bcStatus, setBcStatus] = useState(null);
  const [bcNotes, setBcNotes] = useState("");
  const [bcNotifyNotes, setBcNotifyNotes] = useState("");
  const [newBcObj, setNewBcObj] = useState(null);

  const bcAddEditStatusSelector = useSelector(getBcAddEditStatus);
  const localDocUploadSasUrlSelector = useSelector(getLocalDocUploadSasUrl);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (bcObject) {
      setBcNotifyNotes(bcObject.instructionNotes);
      setBcNotes(bcObject.notes);
      setBcStatus(bcObject.status);
    }
  }, [bcObject])

  const doSubmit = async () => {
    if (bcType === "notify") {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to notify candidate!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: {
          confirmButton: 'swal2-outline-black',
          cancelButton: 'swal2-outline-red'
        },
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();
          confirmButton.innerHTML = `
                        <i class="fa fa-check" style="margin-right: 8px;"></i> Yes`;

          const cancelButton = Swal.getCancelButton();
          cancelButton.innerHTML = `
                        <i class="fa fa-times" style="margin-right: 8px; margin-left:3px;"></i> No`;
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          saveEditBackgroundCheck();
        } else {
          setSaveBtnStatus(false);
        }
      });
    } else {
      saveEditBackgroundCheck();
    }
  };

  const saveEditBackgroundCheck = async () => {
    setSaveBtnStatus(true);

    let wfTask = { ...workItem };
    if (candidateObj?.applications.length > 0)
      wfTask.parentCiid = candidateObj?.applications[0].ciid;

    let data = { ...bcObject };
    if (bcType === "new")
      data = { ...newBcObj };
    data.performerId = candidateObj.performerid;
    data.addedBy = currentUser.id;
    data.notes = bcNotes;
    if (bcType === "notify")
      data.notes = bcNotifyNotes;

    data.status = bcStatus;
    const formData = new FormData();
    formData.append("BackgroundChecks", JSON.stringify(data));
    formData.append("workflowTask", JSON.stringify(wfTask));
    formData.append("editType", bcType);
    // documents.map((file, key) =>
    //   formData.append("files[" + key + "]", file.file)
    // );
    formData.append("files", JSON.stringify(documents.map(x => ({ name: x.name, type: x.type, size: x.size }))));

    dispatch(AddEditBackgroundChecks(formData));
  };


  useEffect(() => {
    if (bcAddEditStatusSelector) {
      getAlert("", "Saved Successfully", "success");
      setDocuments([]);
      setBcNotes("");
      setSaveBtnStatus(false);
      setBcNotifyNotes("");
      handleBcCheckShowHide("save", "");
    }
  }, [bcAddEditStatusSelector])

  useEffect(() => {
    if (localDocUploadSasUrlSelector) {
      console.log("Received SAS URL for local document upload:", localDocUploadSasUrlSelector);
      // You can now use this SAS URL to upload the document directly to Azure Blob Storage
      // For example, you could call a function like uploadFileToBlob(file, localDocUploadSasUrlSelector)
      documents.map((file, key) =>
        uploadFileToBlob(file.file, localDocUploadSasUrlSelector, (progress) => {
          console.log(`Upload progress: ${progress}%`);
        })
      )
    }
  }, [localDocUploadSasUrlSelector]);

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const index = documents.indexOf(item);
    let docs = [...documents];
    if (index !== -1) {
      docs.splice(index, 1);
      setDocuments(docs)
    }
  };

  return (
    <React.Fragment>
      <Modal show={bcCheckShowHide} size="lg">
        <Modal.Header
          closeButton
          onClick={() => handleBcCheckShowHide("", "")}
        >
          <Modal.Title>
            {bcType === "new" && "Add Background Check"}
            {bcType === "edit" && "Internal Notes"}
            {bcType === "notify" && "Notify Candidate"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          <div className="row">
            {bcType === "new" && <>
              <div className="col-md-12 form-group">
                <label htmlFor="" className="form-control-label">
                  Background Check Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  id="name"
                  value={newBcObj?.name}
                  placeholder="Background Check Name"
                  onChange={({ currentTarget }) => setNewBcObj({ ...newBcObj, name: currentTarget.value })}
                />
              </div>
            </>}
            {(bcType === "edit" || bcType === "new") && (
              <div className="col-md-12 form-group">
                <label htmlFor="" className="form-control-label">
                  Notes
                </label>
                <textarea
                  rows={2}
                  cols={2}
                  className="form-control"
                  name="notes"
                  id="notes"
                  value={bcNotes}
                  placeholder="Notes"
                  onChange={({ currentTarget }) => setBcNotes(currentTarget.value)}
                />
              </div>
            )}
            {bcType === "notify" && (
              <div className="col-md-12 form-group">
                <label htmlFor="" className="form-control-label">
                  Notes
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="notes"
                  id="notes"
                  value={bcNotifyNotes}
                  placeholder="Notes"
                  onChange={({ currentTarget }) => setBcNotifyNotes(currentTarget.value)}
                />
              </div>
            )}
            {bcType === "edit" && (
              <div className="col-md-12 form-group form-inline">
                <div className="custom-control custom-radio mb-3">
                  <input
                    name="status"
                    className="custom-control-input"
                    id="activate"
                    type="radio"
                    checked={bcStatus === true}
                    //defaultChecked={bcStatus === true}
                    onChange={() => setBcStatus(true)}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="activate"
                  >
                    Pass
                  </label>
                </div>
                <div className="custom-control custom-radio mb-3 ml-3">
                  <input
                    name="status"
                    className="custom-control-input"
                    id="deactivate"
                    checked={bcStatus === false}
                    type="radio"
                    //defaultChecked={bcStatus === false}
                    onChange={() => setBcStatus(false)}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="deactivate"
                  >
                    Fail
                  </label>
                </div>
              </div>
            )}

            {(bcType === "edit" || bcType === "notify") && (
              <div className="col-md-12">
                <UploadDocument
                  documents={documents}
                  handleFileRemove={handleFileRemove}
                  onFileChange={onFileChange}
                ></UploadDocument>
              </div>
            )}

          </div>
        </Modal.Body>
        {(bcType !== "" || bcType === "new") && (
          <Modal.Footer>
            <Button
              variant="outline-dark"
              size="sm"
              //disabled={saveBtnStatus || this.validate()}
              disabled={saveBtnStatus}
              onClick={doSubmit}
            >
              {saveBtnStatus ? (
                <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
              ) : <i className="fa fa-check mr-1"></i>}
              Save
            </Button>
          </Modal.Footer>
        )}
      </Modal>

    </React.Fragment>
  );
}

export default AddBcChecks;
